import { render, staticRenderFns } from "./CreateGas.vue?vue&type=template&id=781c6c3f&scoped=true&"
import script from "./CreateGas.vue?vue&type=script&lang=js&"
export * from "./CreateGas.vue?vue&type=script&lang=js&"
import style0 from "./CreateGas.vue?vue&type=style&index=0&id=781c6c3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c6c3f",
  null
  
)

component.options.__file = "CreateGas.vue"
export default component.exports